import React from 'react'
import Icon from 'react-icon-base'

export default (props) => {
  return (
    <Icon viewBox='0 0 512 512' {...props}>
      <title id='Person'>{props.title || 'Person'}</title>
      <g><path d='M444.2 355.1c-30.3-13.5-75.3-48.2-142-60.1 17-18.2 29.9-46.8 43.2-80.6 7.7-19.6 6.4-36.3 6.4-60 0-17.6 3.3-45.7-1-61.2-14.7-52.3-51.8-66.8-95.4-66.8-43.5 0-80.7 14.5-95.4 66.9-4.3 15.4-1 43.6-1 61.1 0 23.8-1.3 40.6 6.4 60.2 13.4 34 26.1 62.5 43.1 80.6-66.1 12.2-110.8 46.6-140.9 60.1C5.2 383 4.9 413.4 4.9 413.4v51.7l502.2-.1v-51.7c0 .1-.3-30.4-62.9-58.2z' /></g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/person.js